$(document).ready(function () {
  $(this).scrollTop(0);
  // console.clear();
});
console.warn = () => {};
// try {
//   console.clear();
// } catch (e) {
//   console.clear();
// }
